import { ArrowRight } from 'lucide-react'

import { DiscordIcon } from '@/components/icons/BrandIcons'
import { Button } from '@/components/ui/button'
import { SectionLabel } from '@/features/landing/components/SectionLabel'
import { DISCORD_INVITE_URL } from '@/lib/config/links'

/**
 * Founding-squad band. The alpha numbers (6 weeks, 3 squadrons, 50
 * players) are real but small, so they are framed as founding-member
 * scarcity + a live community, never as popularity magnitude (thin
 * counts read as unpopular — NN/g social-proof research). Designed as
 * one of the two page "peaks"; static per the frequency framework.
 */
export function FoundingSquad() {
  return (
    <section className="relative border-b border-border/60 px-6 py-24 md:py-32">
      <div className="mx-auto max-w-4xl">
        <div className="mb-10 flex flex-col items-start gap-6">
          <SectionLabel index="05" label="Founding squads" />
          <h2 className="font-display max-w-3xl text-4xl leading-[1.05] font-semibold text-balance md:text-6xl">
            Six weeks in. The first players are{' '}
            <span className="gradient-text">building this with us</span>.
          </h2>
          <p className="max-w-2xl text-base text-fg-muted text-pretty md:text-lg">
            e404 is new. A handful of squadrons run on it today, and the
            people in them are shaping what ships next — the features, the
            rough edges, the calls. Get in now and your squad helps decide
            what this becomes.
          </p>
        </div>

        <div className="flex flex-col items-start gap-4 rounded-xl border border-primary/30 bg-surface/80 p-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <span
              aria-hidden
              className="flex size-10 items-center justify-center rounded-lg border border-border bg-bg/60 text-[#5865F2]"
            >
              <DiscordIcon className="size-5" aria-hidden />
            </span>
            <div>
              <p className="font-display text-sm font-semibold text-fg">
                The whole thing runs out in the open, in Discord.
              </p>
              <p className="text-[13px] text-fg-muted">
                That's where the founding squads talk to us. Come see it
                before you sign up.
              </p>
            </div>
          </div>
          <Button asChild variant="outline" size="md" className="shrink-0">
            <a href={DISCORD_INVITE_URL} target="_blank" rel="noreferrer noopener">
              Join the Discord
              <ArrowRight className="size-4" aria-hidden />
            </a>
          </Button>
        </div>
      </div>
    </section>
  )
}
